import React, {Component} from 'react';

class ConfirmationModal extends Component {
    render(){
        return (
            <div className="modal fade show in" tabindex="-1" role="dialog" style={{display: 'block !important', zIndex: (this.props.z) ? this.props.z : '9000'}}>
                <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="bootbox-close-button close" onClick={(e) => this.props.cancel()}  data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 className="modal-title">{this.props.title}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="bootbox-body">{this.props.text}</div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={(e) => this.props.cancel()} type="button" className="btn btn-default w-100">No</button>
                            <button onClick={(e) => this.props.confirm()} type="button" className="btn btn-base w-100">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/ConfirmationModal.js